import React, { memo } from "react";
import * as R from "ramda";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { Field } from "formik";

function SearchableSelectField({
  name,
  label,
  options,
  valueModifier = R.identity,
  isOptional = false,
  isReadOnly = false,
  onChange,
  ...rest
}) {
  const chakraStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 100,
    }),
    valueContainer: (provided) => {
      return {
        ...provided,
        color: isReadOnly ? "tertiaryText" : null,
        backgroundColor: isReadOnly ? "lightBackground" : null,
      };
    },
    indicatorsContainer: (provided) => {
      return {
        ...provided,
        display: isReadOnly ? "none" : "flex",
      };
    },
  };
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const selectedOption = R.defaultTo(
          null,
          R.find(R.propEq("value", valueModifier(field.value)))(options || [])
        );

        return (
          <FormControl
            isInvalid={meta.touched && meta.error}
            isRequired={!isOptional}
            isReadOnly={isReadOnly}
          >
            {label && <FormLabel htmlFor={`searchable-select-${name}`} requiredIndicator={false}>{label}</FormLabel>}
            <Select
              {...field}
              selectedOptionStyle="check"
              {...rest}
              inputId={`searchable-select-${name}`}
              onChange={(selection) => {
                onChange && onChange(selection.value);
                form.setFieldValue(name, selection.value);

                // An issue with Formik and the way they treat validation requires us to fire this call after a short timeout.
                // See: https://github.com/jaredpalmer/formik/issues/2457
                setTimeout(() => {
                  form.setFieldTouched(name, true);
                }, 100);
              }}
              onBlur={() => {
                form.setFieldTouched(name, true);
              }}
              options={options}
              value={selectedOption}
              id={name}
              chakraStyles={chakraStyles}
            />
            <FormErrorMessage>{meta.error}</FormErrorMessage>
          </FormControl>
        );
      }}
    </Field>
  );
}

export default memo(SearchableSelectField);
